import {
  AdvancedFilterDataSchema,
  FilterGroupSchema,
} from "@redotech/redo-model/views/views";
import * as z from "zod";

export const createPickSessionFilter = {
  name: "createPickSessionFilter" as const,
  input: z.object({
    name: z.string(),
    filters: z.array(AdvancedFilterDataSchema),
    filterGroup: FilterGroupSchema.optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
